<template>
  <div>
    <div id="sidebar-wrapper-apps">
      <div
        id="menus"
        class="menus">
        <div class="sidebar__nav--container">
          <div
            class="m__b--25 cursor-pointer display-flex"
            @click="setMenu('home')">
            <img
              src="@/assets/menu/home.png"
              class="icon-menu-sidebar">
            <div
              v-show="menuActive === 'home'"
              class="active-menu-home"/>
          </div>
          <!-- <div
            v-if="isAdmin"
            class="m__b--25 cursor-pointer display-flex"
            @click="setMenu('setting')">
            <img
              src="@/assets/menu/setting.png"
              class="icon-menu-sidebar">
            <div
              v-show="menuActive === 'setting'"
              class="active-menu-setting"/>
          </div> -->
          <div
            v-if="isKurikulum"
            class="m__b--25 cursor-pointer display-flex"
            @click="setMenu('kurikulum')">
            <img
              src="@/assets/menu/kurikulum.png"
              class="icon-menu-sidebar">
            <div
              v-show="menuActive === 'kurikulum'"
              class="active-menu-kurikulum"/>
          </div>
          <div
            v-if="isKesiswaan"
            class="m__b--25 cursor-pointer display-flex"
            @click="setMenu('kesiswaan')">
            <img
              src="@/assets/menu/kesiswaan.png"
              class="icon-menu-sidebar">
            <div
              v-show="menuActive === 'kesiswaan'"
              class="active-menu-kesiswaan"/>
          </div>
          <div
            v-if="isBK"
            class="m__b--25 cursor-pointer display-flex"
            @click="setMenu('bk')">
            <img
              src="@/assets/menu/bk.png"
              class="icon-menu-sidebar">
            <div
              v-show="menuActive === 'bk'"
              class="active-menu-bk"/>
          </div>
          <div
            v-if="isHubin"
            class="m__b--25 cursor-pointer display-flex"
            @click="setMenu('hubin')">
            <img
              src="@/assets/menu/hubin.png"
              class="icon-menu-sidebar">
            <div
              v-show="menuActive === 'hubin'"
              class="active-menu-hubin"/>
          </div>
          <div
            class="m__b--25 cursor-pointer display-flex"
            @click="directToSino()">
            <img
              src="@/assets/menu/sino.png"
              width="40"
              class="icon-menu-sidebar">
          </div>
        </div>
      </div>
    </div>
    <div
      v-if="isExpandMenu"
      id="sidebar-wrapper-apps-expand">
      <div
        id="menus"
        class="menus">
        <div class="sidebar__nav--container-expand">
          <div class="info-module-sidebar">
            <img
              :src="require(`@/assets/menu/${menuActive}.png`)"
              class="m__r--10"
              width="30">
            <div class="title-module-sidebar">{{ moduleActive }}</div>
          </div>
          <transition name="slide-left">
            <ul
              v-show="menu"
              class="sidebar-nav">
              <li
                v-for="(menu, index) in menusItems"
                :key="'nested' + index"
                class="menus-list">
                <j-nested-menu :menu="menu"/>
              </li>
            </ul>
          </transition>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
/* eslint-disable import/no-unresolved,vue/require-default-prop */
/* eslint linebreak-style: ["error", "windows"] */
import { mapState } from 'vuex';
import jNestedMenu from './jNestedMenu';

export default {
  name: 'JSidebarApp',
  components: {
    jNestedMenu,
  },
  props: {
    menusItems: Array,
  },
  /**
     * menu: is menu displayed?
     * menuProduct: is menuProduct displayed?
     * @returns {{menu: boolean, menuProduct: boolean}}
     */
  data() {
    return {
      menuActive: 'home',
      isExpandMenu: false,
      menu: true,
      menuProduct: false,
    };
  },
  computed: {
    ...mapState('jStoreLogin', ['module', 'isHide']),

    moduleActive() {
      let module;
      if (this.menuActive === 'setting') {
        module = 'ADMIN';
      } else if (this.menuActive === 'bk') {
        module = 'BIMBINGAN KONSELING';
      } else if (this.menuActive === 'hubin') {
        module = 'HUBUNGAN INDUSTRI';
      } else {
        module = this.menuActive.toUpperCase();
      }
      return module;
    },

    getJojoLeftIcon() {
      if (this.menuProduct) return 'fa fa-close icon--bold';
      return 'fa fa-bars icon--bold';
    },

    isAdmin() {
      const roles = JSON.parse(localStorage.getItem('roles'));
      const haveAccess = ['admin'];
      return roles.filter(f => haveAccess.includes(f.name)).length > 0;
    },

    isKurikulum() {
      const roles = JSON.parse(localStorage.getItem('roles'));
      const haveAccess = ['admin', 'kepala_sekolah', 'kepegawaian', 'kurikulum', 'wali_kelas', 'kesiswaan', 'guru', 'kajur', 'surat_menyurat'];
      return roles.filter(f => haveAccess.includes(f.name)).length > 0;
    },

    isKesiswaan() {
      const roles = JSON.parse(localStorage.getItem('roles'));
      const haveAccess = ['admin', 'kepala_sekolah', 'kurikulum', 'wali_kelas', 'kesiswaan', 'guru', 'tu', 'sapras', 'hubin', 'tefa', 'kajur', 'siswa'];
      return roles.filter(f => haveAccess.includes(f.name)).length > 0;
    },

    isBK() {
      const roles = JSON.parse(localStorage.getItem('roles'));
      const haveAccess = ['admin', 'kepala_sekolah', 'wali_kelas', 'tu', 'hubin', 'wali_kelas', 'kajur', 'penelusuran_alumni', 'bk'];
      return roles.filter(f => haveAccess.includes(f.name)).length > 0;
    },

    isHubin() {
      const roles = JSON.parse(localStorage.getItem('roles'));
      const haveAccess = ['admin', 'kepala_sekolah', 'kurikulum', 'kesiswaan', 'sapras', 'hubin', 'wali_kelas', 'kajur', 'buku_tamu'];
      return roles.filter(f => haveAccess.includes(f.name)).length > 0;
    },
  },
  watch: {
    module(val) {
      this.setMenu(val);
    },
    isHide() {
      this.isExpandMenu = false;
      this.$emit('set-expand', false, null);
    },
  },
  created() {
    this.setMenu(localStorage.getItem('sidebar'));
  },
  mounted() {
  },
  methods: {
    setMenu(e) {
      localStorage.setItem('sidebar', e);
      if (this.menuActive !== e) {
        this.isExpandMenu = false;
      }
      setTimeout(() => {
        if (this.menuActive === e && e !== 'home') {
          this.isExpandMenu = !this.isExpandMenu;
          this.$emit('set-expand', this.isExpandMenu, e);
        } else {
          this.isExpandMenu = e !== 'home' || false;
          this.$emit('set-expand', this.isExpandMenu, e);
        }

        this.menuActive = e;

        if (e === 'home') {
          this.$router.replace('/home');
        }
      }, 100);
    },

    toggleShow() {
      this.menu = !this.menu;
      this.menuProduct = !this.menuProduct;
    },

    directToSino() {
      window.open(`${process.env.GATE_URL}user/login-sino/${(JSON.parse(localStorage.getItem('Token'))).value}`, '_blank');
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/layouts/sidebar/jSidebarApp.vue